import React, {useContext, useEffect, useRef, useState} from 'react'
import {Link, useLocation} from 'react-router-dom'
import i18next from "i18next"
import {languages} from '../../utils/lang'
import generateLanguageURL from "../../utils/generateLanguageURL";
import {observer} from "mobx-react-lite";
import {LanguageContext} from "../../App";
import cookie from "js-cookie";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";

const Language = ({setMobileMenu}) => {
    const location = useLocation();
    const curr_lang = cookie.get('i18next');
    const [languageContext] = useContext(LanguageContext);

    const blockLanguage = useRef(null);
    const [openLanguageBlock, setOpenLanguageBlock] = useState(false);

    const handleClick = e => {
        const code = e.target.dataset.lang;
        if (e.target.closest('li').classList.contains('active')) {
            e.preventDefault();
        } else {
            if (e.target.href !== window.location.origin.toString() + location.pathname) {
                blockLanguage.current.querySelector('li.active').classList.remove('active');
                e.target.closest('li').classList.add('active');
                blockLanguage.current.append(e.target.closest('li'));
                i18next.changeLanguage(code);
            }
            if (document.body.clientWidth <= 1280) {
                ScrollToPositionFixed(true);
                setMobileMenu(false);
            }
        }
    };

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (openLanguageBlock && blockLanguage.current && !blockLanguage.current.contains(e.target)) {
                setOpenLanguageBlock(false);
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [openLanguageBlock]);

    useEffect(() => {
        setOpenLanguageBlock(false)
    }, [curr_lang]);

    return (
        <div id="js-lang" className="lang">
            <ul
                className={`lang_list ${openLanguageBlock ? 'active' : ''}`}
                ref={blockLanguage}
                style={{width: (openLanguageBlock ? languages.length * 33 : 33) + 'px'}}
                onClick={() => setOpenLanguageBlock(!openLanguageBlock)}
            >
                {languages.map(({code}) => {
                    return <li key={code} className={code === curr_lang ? 'active' : ''}>
                        <Link
                            to={Object.keys(languageContext).length === 0
                                ? generateLanguageURL(location.pathname, code)
                                : languageContext[code]
                                    ? generateLanguageURL(location.pathname, code)
                                    : generateLanguageURL(location.pathname, code)}
                            onClick={handleClick}
                            data-lang={code}
                        >{code.toUpperCase()}</Link>
                    </li>
                })}
            </ul>
        </div>
    );
};

export default observer(Language);